import { graphql } from 'react-apollo'
import compose from 'lodash/fp/compose'
import gql from 'graphql-tag'
import ClientsDataGrid from '../components/ClientsDataGrid'
import { compact, getOr, capitalize } from 'lodash/fp'

const GetCurrentCustomers = gql`
  query GetCurrentCustomers {
    getCustomers {
      customerId
      firstName
      lastName
      phoneNumbers {
        home
      }
      vehicle {
        year
        make
        model
        vin
        plate
      }
    }
  }
`

const DeleteCustomer = gql`
  mutation DeleteCustomer($customerId: ID!) {
    deleteCustomer(customerId: $customerId) {
      customerId
    }
  }
`

const getVehicleDescription = ({ year, make, model }) => compact([year, make, model]).map(capitalize).join(' ')

export default compose(
  graphql(GetCurrentCustomers, {
    props: ({ ownProps, data }) => ({
      loading: data.loading,
      columns: [
        { name: 'name', title: 'Name' },
        { name: 'phoneNumber', title: 'Phone Number' },
        { name: 'vehicle', title: 'Vehicle' },
        { name: 'vin', title: 'VIN' },
        { name: 'plate', title: 'License Plate' }
      ],
      rows: data.getCustomers ? data.getCustomers.map(c => ({
        customerId: c.customerId,
        name: `${c.firstName} ${c.lastName}`,
        phoneNumber: getOr('', 'phoneNumbers.home')(c),
        vehicle: c.vehicle ? getVehicleDescription(c.vehicle) : '',
        vin: c.vehicle ? c.vehicle.vin : '',
        plate: c.vehicle ? c.vehicle.plate : ''
      })) : []
    })
  }),
  graphql(DeleteCustomer, {
    name: 'deleteCustomer'
  })
)(ClientsDataGrid)


// WEBPACK FOOTER //
// ./src/modules/clients/containers/CurrentCustomersGrid.js